import React, { useState, useEffect, useCallback, useRef } from 'react'
import { Row } from 'react-bootstrap'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import { RouteComponentProps } from 'react-router-dom'
import { authAxios } from '../../../API/apiRequest'
import { EmployerLayout } from '../Layout/EmployerLayout'
import ImageViewer from 'react-simple-image-viewer'
import moment from 'moment'
import classes from './EmployerApplication.module.css'
import validator from 'validator'
import { AddAppointment, Reject, UnReject } from '../JobsManager/ApplicationCard/ApplicationCard'

const EmployerApplication: React.FC<RouteComponentProps<{id: string}>> = (props)=>{

    const [profile, setProfile] = useState<any>(null)
    const [textColor, setTextColor] = useState('#fff')
    const [status, setStatus] = useState('')
    const [appointment, setAppointment] = useState<any>(null)
    const [createdAt, setCreatedAt] = useState(0)
    const [address, setAddress] = useState< [] | [{
        label: string;
        value: string;
    }] | undefined>([])
    const [loading, setLoading] = useState(true)
    const [form, setForm] = useState<[] | [{question: string, answer: string}]>([])
    const [currentImage, setCurrentImage] = useState(0);
    const [isViewerOpen, setIsViewerOpen] = useState(false);
    const [showReject, setShowReject] = useState(false)
    const [showUnReject, setShowUnReject] = useState(false)
    const [showAppointment, setShowAppointment] = useState(false)
    const [date, setDate] = useState<string | null>(null)
    const [addressId, setAddressId] = useState<string | undefined>(undefined)
    const [err, setErr] = useState<string>('')
    const myRef = useRef<HTMLDivElement>(null)


    const scrollTop = ()=>{
        if(myRef.current !== null)
            myRef.current.scrollIntoView({behavior: 'smooth'}) 
    }
    const openImageViewer = useCallback((index) => {
      setCurrentImage(index);
      setIsViewerOpen(true);
    }, []);

    const closeImageViewer = () => {
      setCurrentImage(0);
      setIsViewerOpen(false);
    };

    const onDone = async()=>{
        try{
            if(!addressId || !date){
                setErr('من فضلك تأخد من إدخال البيانات بشكل صحيح')
                return
            } 
            if(!validator.isAfter(new Date(date).toString())){
                setErr('من فضلك تأخد من إدخال البيانات بشكل صحيح')
                return
            }
            setShowAppointment(false)
            await authAxios.post(`/employer/applications/${props.match.params.id}/accept`, 
            {date: new Date(date), addressId},
            {headers: {
                  'Content-Type': 'application/json'
            }})
            getApplication()
            return scrollTop()
        }catch(e){
            console.log(e)
        }
    }
    const onChangeDate = (e: any)=>{
        try{
            setDate(e.target.value)
            setErr('')
            if(!validator.isAfter(new Date(e.target.value).toString())){
                setErr('من فضلك تأكد من إدخال التاريخ والوقت بشكل صحيح')
            }
        }catch(e){
            console.log(e)
        }
    }
    const onCancelAppointment = ()=>{
        setShowAppointment(false)
        setDate(null)
        setAddressId(undefined)
        setErr('')
    }
    const onCancel = ()=>{
        setShowReject(false)
        setShowUnReject(false)
    }
    const onReject = async()=>{
        try{
            let result = await authAxios.post(`/employer/applications/${props.match.params.id}/reject`)
            if(result.status === 200){
                setShowReject(false)
                getApplication()
                return scrollTop()
            }

        }catch(e){
            console.log(e)
        }
    }

    const onUnReject = async()=>{
        try{
            let result = await authAxios.put(`/employer/applications/${props.match.params.id}/reject`)
            if(result.status === 200){
                setShowUnReject(false)
                getApplication()
                return scrollTop()
            }
        }catch(e){
            console.log(e)
        }
    }
    async function getApplication(){
        try{
            const result = await authAxios.get(`/employer/applications/${props.match.params.id}`)
            setProfile(result.data.profile)
            setStatus(result.data.status)
            setAppointment(result.data.appointment)
            setCreatedAt(result.data.createdAt)
            setForm(result.data.form)
            switch(result.data.status){
                case 'في انتظار القبول او الرفض':
                    setTextColor('#fff')
                    break;
                case 'تم تحديد موعد للمقابلة':
                    setTextColor('#7BE0AD')
                    break;
                case 'تم رفض الطلب':
                    setTextColor('#EE6C55')
                    break;
                default:
                    break;
            }
            
        }catch(e){
            console.log(e)
        }
        setLoading(false)
    }

    useEffect(()=>{
        
        async function getApplication(){
            try{
                const result = await authAxios.get(`/employer/applications/${props.match.params.id}`)
                const addressRequest = await authAxios.get(`/employer/address`)
                setProfile(result.data.profile)
                setStatus(result.data.status)
                setAppointment(result.data.appointment)
                setCreatedAt(result.data.createdAt)
                setForm(result.data.form)
                setAddress(addressRequest.data.address.map((a: any)=>({label: a.location, value: a.id})))
                switch(result.data.status){
                    case 'في انتظار القبول او الرفض':
                        setTextColor('#fff')
                        break;
                    case 'تم تحديد موعد للمقابلة':
                        setTextColor('#7BE0AD')
                        break;
                    case 'تم رفض الطلب':
                        setTextColor('#EE6C55')
                        break;
                    default:
                        break;
                }
            }catch(e){
                console.log(e)
            }
            setLoading(false)
        }
        getApplication()
    },[props.match.params.id])

    if(loading) return <LoadingApplication />
    return(
        <EmployerLayout>
           
            <Row ref={myRef}>
            <Reject onReject={onReject} onCancel={onCancel} show={showReject}  />  
            <UnReject onReject={onUnReject} onCancel={onCancel} show={showUnReject}  />  
            <AddAppointment
                show={showAppointment}
                onCancel={onCancelAppointment}
                onReject={onDone}
                address={address}
                onChangeDate={onChangeDate}
                onSelectAddress={(a)=>setAddressId(a?.value)}
                err={err}
                />
                <p dir='rtl' style={{textAlign: 'right', color: '#BBBBBB', padding: 0, margin: 0}}>حالة الطلب:</p>
                <div style={{width: '100%', backgroundColor: '#2F4550', padding: 0, margin: 0, borderRadius: 3}}>
                    <p dir='rtl' style={{textAlign: 'right', color: textColor, paddingRight: 8}}>{status}</p>
                </div>
            </Row>
            {appointment && <Row>
                <p dir='rtl' style={{textAlign: 'right', color: '#BBBBBB', padding: 0, margin: 0}}>مقابلة شخصية:</p>
                <div style={{width: '100%', backgroundColor: '#586F7C', padding: 0, margin: 0, borderRadius: 3}}>
                    <p dir='rtl' style={{textAlign: 'center', color: '#fff', paddingRight: 8}}>
                        {moment(appointment.date).format('Do MMMM YYYY')}
                    </p>
                    <p dir='rtl' style={{textAlign: 'center', color: '#fff', paddingRight: 8}}>
                        {moment(appointment.date).format('h:mm a')}
                    </p>
                    <p dir='rtl' style={{textAlign: 'center', color: '#fff', paddingRight: 8}}>
                        {appointment?.address}
                    </p>
                </div>
            </Row>}
            <Row style={{marginTop: 15}}>
                {isViewerOpen && (
                    <ImageViewer
                    src={[profile.picture]}
                    currentIndex={currentImage}
                    onClose={closeImageViewer}
                    disableScroll={false}
                    backgroundStyle={{
                        backgroundColor: "rgba(0,0,0,0.9)"
                    }}
                    closeOnClickOutside={true}
                    />
                )}
                <div className='col-md d-flex p-0' style={{justifyContent: 'center', alignItems: 'center'}}>
                    <img 
                        onClick={() => openImageViewer(0)}
                        alt={'الصورة الشخصية'} 
                        style={{
                            color: '#fff', 
                            margin: 0, 
                            padding: 0, 
                            width: 190, 
                            height: 150, 
                            objectFit: 'cover', 
                            borderRadius: 5,
                            boxShadow: 'rgba(0, 0, 0, 0.05) 20px 15px 16px, rgba(0, 0, 0, 0.05) 0px 8px 32px',
                         }}
                        src={profile.picture}
                    />
                </div>
            </Row>
            <Row style={{marginTop: 5}}>
                <div className='col-md d-flex p-0' style={{justifyContent: 'center', alignItems: 'center'}}>
                    <p 
                        style={{
                            color: '#fff', 
                            marginTop: 10, 
                            padding: 0, 
                            lineHeight: 'inherit', 
                            textAlign: 'center',
                            fontSize: 28
                        }}
                    >
                        {profile && profile.name}
                    </p>
                </div>
            </Row>
            <ProfileInfo 
              title={'وقت إرسال الطلب'}
              value={createdAt ? moment(new Date(createdAt)).locale('ar').fromNow() : ''}
            />
            {form.length > 0 && <ProfileInfo 
              title={'اسئلة الوظيفة'}
              value={form}
            />}
            {profile?.description && profile.description !== '' && <ProfileInfo 
              title={'وصف'}
              value={profile ? profile.description : ''}
            />}
            <PersonCV 
              value={profile.cv}
            />
            <ProfileInfo 
              title={'رقم الهاتف'}
              value={profile ? profile.phone : ''}
            />
            <ProfileInfo 
              title={'البريد الإلكتروني'}
              value={profile ? profile.email : ''}
            />
            <ProfileInfo 
              title={'النوع'}
              value={profile ? profile.gender : ''}
            />
            <ProfileInfo 
              title={'المجال'}
              value={profile ? profile.field : ''}
            />
            <ProfileInfo 
              title={'التخصص'}
              value={profile ? profile.specialty : ''}
            />
            {profile?.militaryStatus && <ProfileInfo 
              title={'الخدمة العسكرية'}
              value={profile ? profile.militaryStatus : ''}
            />}
            <ProfileInfo 
              title={'السن'}
              value={profile ? profile.age : ''}
            />
            <ProfileInfo 
              title={'يقيم في السادات'}
              value={profile ? profile.isSadat : ''}
            />
            <ProfileInfo 
              title={'العنوان'}
              value={profile ? profile.address : ''}
            />
            <ProfileInfo 
              title={'المستوي التعليمي'}
              value={profile ? profile.edu : ''}
            />
            <Row style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginBottom: 25}}>
                {status !== 'تم تحديد موعد للمقابلة' && <div onClick={status === 'تم رفض الطلب' ? ()=>setShowUnReject(true) : ()=>setShowReject(true)} className={'col-5 '+classes.rejectBtn}>
                    <p style={{padding: 5, margin: 0, color: '#fff', textAlign: 'center'}}>
                        {status === 'تم رفض الطلب' ? 'إلفاء الرفض' : 'مرفوض'}
                    </p>
                </div>}
                <div onClick={()=>setShowAppointment(true)} className={'col-5 '+classes.acceptBtn}>
                      <p style={{padding: 5, margin: 0, color: '#fff', textAlign: 'center'}}>
                          {status === 'تم تحديد موعد للمقابلة' ? 'تغيير الموعد' : 'تحديد موعد'}
                       </p>
                </div>
            </Row>
        </EmployerLayout>
    )
}


const PersonCV: React.FC<{value: string}> = (props)=>{

    return(
        <Row className='mb-2'>
                <div className='col p-0'>
                    <div dir='rtl' style={{
                        display: 'flex', 
                        flexDirection: 'row', 
                        justifyContent: 'flex-start', 
                        alignItems: 'center',
                        backgroundColor: '#343a40',
                        padding: '2px 10px',
                        borderRadius: 5
                        }}>
                    <p 
                        dir='rtl'
                        style={{
                            color: 'gray', 
                            marginTop: 10, 
                            padding: 0, 
                            lineHeight: 'inherit', 
                            textAlign: 'right', 
                            width: 125                       
                        }}
                    >
                       السيرة الذاتية:
                    </p>
                    {props.value !== null ? <a 
                        href={props.value}
                        style={{
                            color: '#17d517', 
                            padding: 0, 
                            lineHeight: 'inherit', 
                            textAlign: 'right',
                            whiteSpace: 'pre-line',
                            flex: 1
                        }}
                    >
                        عرض السيرة الذاتية
                    </a> : <p 
                        style={{
                            color: '#f76349', 
                            marginTop: 10, 
                            padding: 0, 
                            lineHeight: 'inherit', 
                            textAlign: 'right',
                            whiteSpace: 'pre-line',
                            flex: 1
            
                        }}
                    >
                       لا يوجد سيرة ذاتية
                    </p>
                    }
                    </div>
                </div>
            </Row>
    )
}


const ProfileInfo: React.FC<{title: string, value: string | null | number | [] | [{question: string, answer: string}]}> = (props)=>{

    return (
        <Row className='mb-2'>
                <div className='col p-0'>
                    <div dir='rtl' style={{
                        display: 'flex', 
                        flexDirection: 'row', 
                        justifyContent: 'flex-start', 
                        alignItems: 'center',
                        backgroundColor: '#343a40',
                        padding: '2px 10px',
                        borderRadius: 5
                        }}>
                    <p 
                        dir='rtl'
                        style={{
                            color: 'gray', 
                            marginTop: 10, 
                            padding: 0, 
                            lineHeight: 'inherit', 
                            textAlign: 'right', 
                            alignSelf: 'flex-start',
                            width: 125                       
                        }}
                    >
                       {props.title}:
                    </p>
                    {Array.isArray(props.value) && (
                    <div> {props.value.map((f, index)=>(
                        <div style={{display: 'block'}} key={index}>
                        <p style={{color: 'wheat'}}>
                            {f.question}
                        </p>
                        <p style={{color: '#fff'}}>
                            {f.answer}
                        </p>
                    </div>))}
                    </div>)}
                    <p 
                        style={{
                            color: '#fff', 
                            marginTop: 10, 
                            padding: 0, 
                            lineHeight: 'inherit', 
                            textAlign: 'right',
                            whiteSpace: 'pre-line',
                            flex: 1
                        }}
                    >
                       {!Array.isArray(props.value) && props.value}
                    </p>
                    </div>
                </div>
            </Row>
    )

} 


const LoadingApplication: React.FC = ()=>{
    return(
        <EmployerLayout>
            <SkeletonTheme baseColor="gray" highlightColor="#fff">
            <div className='row mx-0 justify-content-center'>
              <div className='col-md'>
                <div className='col-md justify-content-center m-auto'>
                    <p><Skeleton direction='rtl' height={40} duration={0.8} /></p>
                 </div> 
              </div>
              </div>
            <div className='col'>
                <p style={{textAlign: 'center'}}><Skeleton direction='rtl' duration={0.8} /></p>
            </div>
            <div className='col-md justify-content-center m-auto'>
             <p><Skeleton direction='rtl' height={100} duration={0.8} /></p>
             <p><Skeleton direction='rtl' height={100} duration={0.8} /></p>
            </div>
          </SkeletonTheme>
        </EmployerLayout>
    )
} 

export default EmployerApplication